import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'afs-winner-card',
  styleUrl: 'afs-winner-card.sass',
  shadow: true,
})
export class AfsWinnerCard {

  @Prop() heading : string = "GRAND WINNER OF DRAW 1";
  @Prop() winningNumber : string;
  @Prop() name : string;
  @Prop() prize : string;
  @Prop() drawDate : string;
  @Prop() backgroundColor : string = "#222222";
  @Prop() color : string = "#FFFFFF";
  @Prop() fr : boolean = false;

  @Prop() langWinningNumber : string = this.fr ? "Numéro gagnant" : "Winning Number";
  @Prop() langName : string = this.fr ? "Nom" : "Name";
  @Prop() langDrawDate : string = this.fr ? "Date du tirage" : "Draw Date";
  @Prop() langPrize : string = this.fr ? "Prix" : "Prize";

  render() {
    return (
      <Host style={{
        backgroundColor: this.backgroundColor,
        color: this.color,
      }}>
        <h4>{this.heading}</h4>
        <afs-flex-wrapper direction="column" slot-height="fit-content">
          {this.winningNumber &&<div>
            <span>{this.langWinningNumber}</span>
            <h4>{ this.winningNumber }</h4>
          </div>}
          {this.name && <div>
            <span>{this.langName}</span>
            <h4>{this.name}</h4>
          </div>}
          {this.drawDate && <div>
            <span>{this.langDrawDate}</span>
            <h4>{this.drawDate}</h4>
          </div>}
          {this.prize && <div>
            <span>{this.langPrize}</span>
            <h4>{this.prize}</h4>
          </div>}
        </afs-flex-wrapper>
      </Host>
    );
  }

}
